
const getWeddingText = (brideFirstName: string, groomFirstName: string) => {
  if (brideFirstName && groomFirstName) {
    return `${brideFirstName} & ${groomFirstName}`;
  } else if (brideFirstName) {
    return `${brideFirstName}`;
  } else if (groomFirstName) {
    return `${groomFirstName}`;
  }

  return `...`;
};

export default getWeddingText;
